// extracted by mini-css-extract-plugin
export default {"section_header":"_SectionHeader_section_header__y7s8P","icon":"_SectionHeader_icon__-exQG","title":"_SectionHeader_title__HpJuy","centered":"_SectionHeader_centered__BbmFA"};